<template>
  <div v-hotkey="keymap" class="">
    <div class="controls-inner">
      <div class="pane"  v-bind:style="{ flex: subPanesStatus.optionsOpen ? 'auto' : 'none' }">
        <nikud-options-pane :sub-panes-status="subPanesStatus" :modes-obj="modesObj" :edit-nikud-props="editNikudProps" />
      </div>
      <div class="pane">
        <manual-nikud-pane :sub-panes-status="subPanesStatus" :modes-obj="modesObj" :edit-nikud-props="editNikudProps" />
      </div>
    </div>
    <div id="changes-applied-msg" class="notify-msg" style="display:none;">
        <p class="f white">text will be filled in by code</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NikudOptionsPane from './NikudOptionsPane'
import ManualNikudPane from './ManualNikudPane'
import nikudMixins from '@/mixins/nikudMixins'

export default {
  name: 'NikudPaneContainer',
  components: {
    NikudOptionsPane,
    ManualNikudPane
  },
  props: ['modesObj', 'editNikudProps'],
  mixins: [nikudMixins], // for modalOpen()
  data () {
    return {
      subPanesStatus: {
        optionsOpen: true,
        manualOpen: true
      },
      showKeyboard: false,
      keymap: {
        'shift+p': () => {
          if (!(this.modalOpen())) {
            if (this.subPanesStatus.manualOpen && !(this.subPanesStatus.optionsOpen)) {
              this.subPanesStatus.optionsOpen = true
            } else if (this.subPanesStatus.optionsOpen && !(this.subPanesStatus.manualOpen)) {
              this.subPanesStatus.manualOpen = true
            } else /* both already open */ this.subPanesStatus.manualOpen = false // MAY be desired
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* DocumentSettings-specific CSS goes here */
  .controls-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .notify-msg {
    position: fixed;
    left: 24px;
    bottom: 48px;
    width: 238px;
    height: 50px;
    padding: 15px 8px;
    text-align: center;
    border-radius: 3px;
    box-sizing: border-box;
    background-color: #494949;
  }
  .notify-msg p{
    margin: 0;
    color: white;
  }
  .pane {
    border-radius: 4px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  }
  .pane:not(:last-child) {
    margin-bottom: 13px;
  }
</style>
